export const LoadingMessages = ["Great service takes just a moment! ☀️", "Preparing guest details... A few seconds left ⌛"];
